
import { IconButton } from '@material-ui/core';
import _ from 'lodash';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import momentTz from 'moment-timezone';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { GREEN, RED, SUBSCRIPTION_TYPES } from '../../../_config/consts';
import * as CredentialActions from '../../../redux/actions/credential.actions';
import * as ModalActions from '../../../redux/actions/modal.actions';
import * as TagActions from '../../../redux/actions/tag.actions';
import * as UserActions from '../../../redux/actions/user.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import ArrowLeftIconCustom from '../../CustomIcons/ArrowLeftIconCustom.jsx';
import CheckOutlineIconCustom from '../../CustomIcons/CheckOutlineIconCustom.jsx';
import MDButton from '../../MDButton/MDButton.jsx';
import MewsSelectEnterpriseForm from '../../forms/Integrations/MewsSelectEnterpriseForm.jsx';
import MewsActivationForm from '../../forms/Integrations/MewsActivationForm.jsx';
import { localizeHelpCenterLink } from '../../../_config/utils.js';


@connect(state => ({
  language: state.settings.language,
  lockTags: state.tags.lock.data,
  locksFilteredByTags: _.get(state, 'credentials.selectedCredential.locksFilteredByTags'),
}))
class MewsSettingsOperationalSection extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isActive: null,
      mewsData: {
        accessToken: null,
        enterprises: null,
      },
    };
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    const isActive = dispatch(UserActions.userHasIntegrationActive(SUBSCRIPTION_TYPES.MEWS_INTEGRATION));
    this.setState({ isActive });
  }

  componentDidUpdate(prevProps, prevState) {
    const { mewsData: { enterprises: prevEnterprises } } = prevState;
    const { mewsData: { enterprises } } = this.state;
    if (enterprises && !prevEnterprises) {
      const { dispatch } = this.props;
      const includeSpecialTags = true;
      dispatch(TagActions.fetchLockTags(includeSpecialTags, 0, 200));
    }
  }

  async onMewsActivateAndGetBusiness(loginData) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const enterprises = await dispatch(UserActions.loginWithMewsAndGetEnterprises(loginData.accessToken));
      if (enterprises) {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        const mewsData = {
          accessToken: loginData.accessToken,
          enterprises,
        };
        this.setState({ mewsData });
      }
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      let errorMessage = 'integrationConnectionError';
      if (error && error.message === 'MEWS_ACTIVATION_FAILED_NO_BUSINESSES') {
        errorMessage = 'nexudusErrorNoBusiness';
      }
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity={errorMessage} /></h6>),
        },
      }));
    }
  }

  async onActivateMewsIntegration(formData) {
    const { dispatch } = this.props;
    const { mewsData: { accessToken, enterprises } } = this.state;

    const reservationsSyncMode = [];
    if (formData.pin) {
      reservationsSyncMode.push('PIN');
    }
    if (formData.credentialRule) {
      reservationsSyncMode.push('CREDENTIAL_RULE');
    }
    if (formData.invitation) {
      reservationsSyncMode.push('INVITATION');
    }
    if (reservationsSyncMode.length === 0) {
      return;
    }

    dispatch(UtilsActions.setSpinnerVisibile(true));
    const selectedBusinessIds = formData.enterprises || [];
    const enterprisesSelected = _.filter(enterprises, enterprise => selectedBusinessIds.includes(enterprise.id));
    const preCheckinEnabled = !!formData.preCheckinEnabled;
    const lockTags = formData.lockTags
      ? _.filter(formData.lockTags, tag => tag.type !== 'private_unit')
      : [];
    const preCheckinPinLockTagId = preCheckinEnabled && lockTags.length
      ? lockTags[0].id
      : 0;

    try {
      await dispatch(UserActions.activateMewsIntegrationForBusiness(accessToken, enterprisesSelected, {
        coldStart: formData.coldStartResources,
        reservationsDaysBefore: Number(formData.reservationsDaysBefore) || 0,
        reservationsDaysAfter: Number(formData.reservationsDaysAfter) || 0,
        preCheckinEnabled,
        preCheckinPinLockTagId,
        preCheckinCleanupEnabled: !!formData.preCheckinCleanupEnabled,
        reservationsSyncMode,
        ignoreFlagOwnerCheckedIn: !!formData.ignoreFlagOwnerCheckedIn,
        timeZone: formData.timezone || momentTz.tz.guess(),
      }));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(UserActions.fetchCurrentActiveIntegrations());
      this.setState({ isActive: true });
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="integrationConnectionSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationConnectionError" /></h6>),
        },
      }));
    }
  }

  onDeactivateIntegrationRequest() {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="disableIntegrationConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => this.onDeactivateIntegration(),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeactivateIntegration() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const mewsIntegrationDTO = dispatch(UserActions.getActiveIntegration(SUBSCRIPTION_TYPES.MEWS_INTEGRATION));
      if (mewsIntegrationDTO && mewsIntegrationDTO.id) {
        await dispatch(UserActions.disableIntegration(mewsIntegrationDTO.id));
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(UserActions.fetchCurrentActiveIntegrations());
        this.setState({ isActive: false });
        dispatch(ModalActions.showModal({
          modalType: 'SUCCESS_ALERT',
          modalProps: {
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedSuccess" /></h6>),
          },
        }));
      } else {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalActions.showModal({
          modalType: 'ERROR_ALERT',
          modalProps: {
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
          },
        }));
      }
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
        },
      }));
    }
  }

  onOpenActivationInfo() {
    const helpURL = localizeHelpCenterLink('');
    window.open(helpURL);
  }

  onGoBackToLogin() {
    const mewsData = {
      accessToken: null,
      enterprises: null,
    };
    this.setState({ mewsData })
  }

  filterLockTags(value) {
    const { dispatch } = this.props;
    const includeSpecialTags = true;
    dispatch(TagActions.cancelFetchLockTagsByFilter());
    dispatch(TagActions.fetchLockTagsByFilter(value, 200, includeSpecialTags));
  }

  fetchLocksByTags(page, append) {
    const { dispatch } = this.props;
    dispatch((dispatchInner, getState) => {
      const form = getState().form.MewsSelectEnterpriseForm;
      dispatchInner(CredentialActions.fetchLocksByTagsForm(form, 0, page, append));
    });
  }

  render() {
    const { isActive, mewsData: { enterprises } } = this.state;
    const { dispatch, lockTags, locksFilteredByTags } = this.props;
    return (
      <div style={{ paddingLeft: 20, paddingRight: 25, paddingTop: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <img alt="nexudus" src="/imgs/common/integrationLogos/mews-logo.png" style={{ height: 50, alignSelf: 'center' }} />
        {isActive ? (
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
            <div style={{ width: '70%', margin: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <CheckOutlineIconCustom style={{ color: GREEN, width: 30, marginRight: 10 }} />
              <h4 style={{ color: GREEN, fontWeight: 'bold', fontSize: 20 }}><Entity entity="integrationCorrectlyConfigured" /></h4>
            </div>
            <MDButton
              title={<Entity key={isActive} entity="disableIntegrationTitle" />}
              titleStyle={{ marginTop: 0, fontSize: 13 }}
              backgroundColor={RED}
              containerStyle={{ margin: 0, marginTop: 10, width: '80%' }}
              onClick={() => this.onDeactivateIntegrationRequest()}
            />
          </div>
        ) : (
          <div style={{ width: '70%', margin: 'auto' }}>
            <h4 style={{ color: '#3f3f3f', textAlign: 'center', marginTop: 10, marginBottom: 30 }}><Entity entity="connectYoutAccount" /></h4>
            {!enterprises ? (
              <div>
                <div style={{ marginTop: 20 }}>
                  <MewsActivationForm
                    onSubmit={loginData => this.onMewsActivateAndGetBusiness(loginData)}
                  />
                </div>
                <MDButton
                  title={<Entity entity="activate" key={enterprises} />}
                  titleStyle={{ marginTop: 0, fontSize: 13 }}
                  backgroundColor="black"
                  containerStyle={{ margin: 0, marginTop: 10, marginBottom: 10 }}
                  onClick={() => dispatch(submit('MewsActivationForm'))}
                />
              </div>
            ) : (
              <div>
                <div style={{ marginTop: 20 }}>
                  <MewsSelectEnterpriseForm
                    enterprises={enterprises}
                    availableLockTags={lockTags}
                    locksFilteredByTags={locksFilteredByTags}
                    onFetchMoreLocks={page => this.fetchLocksByTags(page, true)}
                    onLockInputChange={value => this.filterLockTags(value)}
                    onLockTagsChange={() => this.fetchLocksByTags()}
                    onLockFilterModeChange={() => this.fetchLocksByTags()}
                    onSubmit={businessData => this.onActivateMewsIntegration(businessData)}
                  />
                </div>
                <MDButton
                  title={<Entity key={enterprises} entity="connectYourAccount" />}
                  titleStyle={{ marginTop: 0, fontSize: 13 }}
                  backgroundColor="black"
                  containerStyle={{ margin: 0, marginTop: 10 }}
                  onClick={() => dispatch(submit('MewsSelectEnterpriseForm'))}
                />
                <IconButton onClick={() => this.onGoBackToLogin()}>
                  <ArrowLeftIconCustom style={{ color: '#3f3f3f', width: 20, marginRight: 5 }} />
                </IconButton>
                <Entity style={{ color: '#3f3f3f', marginTop: 2 }} entity="backToLogin" />
              </div>
          )}
          </div>
        )}
        <h5
          className="link-label"
          style={{ margin: 'auto', width: 'fit-content', marginTop: 20, fontSize: 16, textDecoration: 'underline' }}
          onClick={() => this.onOpenActivationInfo()}
        >
          <Entity entity="findOutMore" />
        </h5>
      </div>
    );
  }
}

export default MewsSettingsOperationalSection;
